import { type UseModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
// TODO: Use our own Button
// eslint-disable-next-line no-restricted-imports
import { Button, DialogContent } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";
import { convertToGeoLocation, convertToGoogleMapsLocation } from "@src/appV2/Location";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { WorkplaceProfileModalContentSkeleton } from "@src/appV2/redesign/Workplace/Profile/ModalContentSkeleton";
import { type WorkplaceProfile } from "@src/appV2/redesign/Workplace/types";
import { useRef } from "react";
import { useHistory } from "react-router-dom";

import { getWorkplacePlacementsPath } from "../paths";
import { WorkplaceProfileOverview } from "./WorkplaceProfileOverview";

interface WorkplaceProfileModalProps {
  modalState: UseModalState;
  workplaceId: string;
  workplace?: WorkplaceProfile;
  isLoading?: boolean;
  sourcePlacementId?: string;
}

export function WorkplaceProfileModal(props: WorkplaceProfileModalProps) {
  const { modalState, workplaceId, workplace, isLoading, sourcePlacementId } = props;

  const history = useHistory();

  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <FullScreenDialog skipTopSafeAreaPadding modalState={modalState} variant="primary">
      <StickyScrollPageHeader
        hideBackButton
        title={workplace?.name ?? ""}
        isLoading={isLoading}
        scrollContainerRef={scrollRef}
      />

      <DialogContent ref={scrollRef} sx={{ px: 7, pt: 0 }}>
        {isLoading && !isDefined(workplace) && <WorkplaceProfileModalContentSkeleton />}
        {isDefined(workplace) ? (
          <WorkplaceProfileOverview
            name={workplace.name}
            type={String(workplace.type)}
            workplaceId={String(workplaceId)}
            phoneNumber={workplace.phone}
            location={convertToGoogleMapsLocation(
              convertToGeoLocation(workplace.geoLocation.coordinates)
            )}
            formattedAddress={workplace.fullAddress?.formatted}
            sourcePlacementId={sourcePlacementId}
          />
        ) : undefined}
      </DialogContent>

      <DialogFooter
        withShadow
        orientation="horizontal"
        backgroundColor={(theme) => String(theme.palette.background.tertiary)}
        onClose={() => {
          modalState.closeModal();
        }}
      >
        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ maxWidth: "60%" }}
          onClick={() => {
            history.push(getWorkplacePlacementsPath(workplaceId, "workplace-profile-modal"));
          }}
        >
          View jobs
        </Button>
      </DialogFooter>
    </FullScreenDialog>
  );
}
